import { defaultFeatureFlags, FeatureFlags } from '../../featureFlags/featureFlags';
import type { TenantBrandingDto } from '../../branding/resolveCmsBranding';
import {
  AdminMode,
  readStoredAdminMode,
} from '../../utils/adminMode';

const initialState = {
  pendingItemsApprovalCount: 0,
  functionDescriptors: [],
  featureFlags: defaultFeatureFlags as FeatureFlags,
  tenantBranding: null as TenantBrandingDto | null,
  adminMode: (readStoredAdminMode() ?? 'tenant') as AdminMode,
};

export const appReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "LOAD_APP_STATUS":
      return {
        ...state,
        pendingItemsApprovalCount: action.payload.pendingItemsApprovalCount,
      };
    case "LOAD_FUNCTION_DESCRIPTORS":
      return {
        ...state,
        functionDescriptors: action.payload,
      };
    case "LOAD_FEATURE_FLAGS":
      return {
        ...state,
        featureFlags: {
          ...defaultFeatureFlags,
          ...action.payload,
        },
      };
    case "LOAD_TENANT_BRANDING":
      return {
        ...state,
        tenantBranding: action.payload ?? null,
      };
    case "SET_ADMIN_MODE":
      return {
        ...state,
        adminMode: action.payload as AdminMode,
      };
    case "DECREASE_APPROVAL_COUNT":
      return {
        ...state,
        pendingItemsApprovalCount: state.pendingItemsApprovalCount - 1,
      };
    default:
      return state;
  }
};
